import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { secondsToMilliseconds } from 'date-fns';
import { ChoiceDataType } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import { formatDate } from '@yoweb/utils/date';
import { convertPostalAddressToUserAddress } from '@poplar/utils/user';
import { getAnswerValues as getDateTimeAnswerValues, getInitialValues as getDateTimeInitialValues } from './DateTime';
import { uploadNewDocuments } from '@poplar/utils/tasks';
import { formatAddress } from '@poplar/utils/address';
import { I_DO_NOT_KNOW_ID, MONEY_NANOS_MAX } from '@poplar/constants/intake';
import { OTHER_OPTION_VALUE } from './SingleChoice';
import { answerOptionSortFn } from '@poplar/components/Questions/QuestionElements';
export var getTimeDateSummary = function getTimeDateSummary(seconds, options) {
  return seconds ? formatDate(new Date(secondsToMilliseconds(seconds)), options) : undefined;
};
export var getChoiceAnswerValue = function getChoiceAnswerValue(answeredValue, type) {
  switch (type) {
    case ChoiceDataType.CHOICE_DATA_TYPE_STRING:
      return {
        stringValue: {
          value: answeredValue
        }
      };

    case ChoiceDataType.CHOICE_DATA_TYPE_LOCALIZED_TEXT:
      return {
        localizedTextValue: {
          text: answeredValue,
          key: ''
        }
      };

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE_TIME:
      {
        var _ref = answeredValue,
            date = _ref.date,
            time = _ref.time;
        return {
          dateTimeValue: getDateTimeAnswerValues(date, time)
        };
      }

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE:
      return {
        dateValue: {
          seconds: Number(answeredValue),
          nanos: 0
        }
      };

    case ChoiceDataType.CHOICE_DATA_TYPE_POSTAL_ADDRESS:
      {
        var _ref2 = answeredValue,
            city = _ref2.city,
            country = _ref2.country,
            postalCode = _ref2.postalCode,
            region = _ref2.region,
            street1 = _ref2.street1,
            street2 = _ref2.street2;
        return {
          addressValue: {
            locality: city,
            regionCode: country,
            postalCode: postalCode,
            administrativeArea: region,
            addressLinesList: [street1, street2]
          }
        };
      }

    default:
      throw new Error("Invalid choice data type: ".concat(type));
  }
};
export var compareChoiceValues = function compareChoiceValues(a, b, type) {
  switch (type) {
    case ChoiceDataType.CHOICE_DATA_TYPE_STRING:
    case ChoiceDataType.CHOICE_DATA_TYPE_LOCALIZED_TEXT:
    case ChoiceDataType.CHOICE_DATA_TYPE_DATE:
      return a === b;

    case ChoiceDataType.CHOICE_DATA_TYPE_POSTAL_ADDRESS:
      {
        var aAddr = a;
        var bAddr = b;
        return aAddr.street1 === bAddr.street1 && aAddr.street2 === bAddr.street2 && aAddr.city === bAddr.city && aAddr.region === bAddr.region && aAddr.postalCode === bAddr.postalCode && aAddr.country === bAddr.country;
      }

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE_TIME:
      {
        var aDateTime = a;
        var bDateTime = b;
        return aDateTime.date === bDateTime.date && aDateTime.time === bDateTime.time;
      }

    default:
      return false;
  }
};
export var getChoiceValue = function getChoiceValue(answer, type) {
  var _answer$stringValue$v, _answer$stringValue, _answer$localizedText, _answer$localizedText2, _answer$dateTimeValue, _answer$dateValue$sec, _answer$dateValue;

  var country = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  switch (type) {
    case ChoiceDataType.CHOICE_DATA_TYPE_STRING:
      return (_answer$stringValue$v = answer === null || answer === void 0 ? void 0 : (_answer$stringValue = answer.stringValue) === null || _answer$stringValue === void 0 ? void 0 : _answer$stringValue.value) !== null && _answer$stringValue$v !== void 0 ? _answer$stringValue$v : '';

    case ChoiceDataType.CHOICE_DATA_TYPE_LOCALIZED_TEXT:
      return (_answer$localizedText = answer === null || answer === void 0 ? void 0 : (_answer$localizedText2 = answer.localizedTextValue) === null || _answer$localizedText2 === void 0 ? void 0 : _answer$localizedText2.text) !== null && _answer$localizedText !== void 0 ? _answer$localizedText : '';

    case ChoiceDataType.CHOICE_DATA_TYPE_POSTAL_ADDRESS:
      return convertPostalAddressToUserAddress(answer === null || answer === void 0 ? void 0 : answer.addressValue, country);

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE_TIME:
      return getDateTimeInitialValues(answer === null || answer === void 0 ? void 0 : (_answer$dateTimeValue = answer.dateTimeValue) === null || _answer$dateTimeValue === void 0 ? void 0 : _answer$dateTimeValue.seconds);

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE:
      return String((_answer$dateValue$sec = answer === null || answer === void 0 ? void 0 : (_answer$dateValue = answer.dateValue) === null || _answer$dateValue === void 0 ? void 0 : _answer$dateValue.seconds) !== null && _answer$dateValue$sec !== void 0 ? _answer$dateValue$sec : '');

    default:
      throw new Error("Invalid choice data type: ".concat(type));
  }
};
export var getFormattedChoiceValue = function getFormattedChoiceValue(answer, type, locale, timeZone) {
  var _answer$stringValue2, _answer$localizedText3;

  switch (type) {
    case ChoiceDataType.CHOICE_DATA_TYPE_STRING:
      return answer === null || answer === void 0 ? void 0 : (_answer$stringValue2 = answer.stringValue) === null || _answer$stringValue2 === void 0 ? void 0 : _answer$stringValue2.value;

    case ChoiceDataType.CHOICE_DATA_TYPE_LOCALIZED_TEXT:
      return answer === null || answer === void 0 ? void 0 : (_answer$localizedText3 = answer.localizedTextValue) === null || _answer$localizedText3 === void 0 ? void 0 : _answer$localizedText3.text;

    case ChoiceDataType.CHOICE_DATA_TYPE_POSTAL_ADDRESS:
      return getLocalizedAddressString(answer === null || answer === void 0 ? void 0 : answer.addressValue, locale);

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE_TIME:
      {
        var _answer$dateTimeValue2;

        var seconds = answer === null || answer === void 0 ? void 0 : (_answer$dateTimeValue2 = answer.dateTimeValue) === null || _answer$dateTimeValue2 === void 0 ? void 0 : _answer$dateTimeValue2.seconds;
        return getTimeDateSummary(seconds, {
          locale: locale,
          timeZone: timeZone,
          preset: 'timeAndDate'
        });
      }

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE:
      {
        var _answer$dateValue2;

        var _seconds = answer === null || answer === void 0 ? void 0 : (_answer$dateValue2 = answer.dateValue) === null || _answer$dateValue2 === void 0 ? void 0 : _answer$dateValue2.seconds;

        return getTimeDateSummary(_seconds, {
          locale: locale,
          timeZone: timeZone,
          preset: 'defaults'
        });
      }

    default:
      return;
  }
};
export var getLocalizedAddressString = function getLocalizedAddressString(address, locale) {
  if (!address) {
    return;
  }

  var userAddress = convertPostalAddressToUserAddress(address, '');
  return formatAddress(userAddress, locale);
};
export var validateAnswerOption = function validateAnswerOption(answerOption) {
  var _answerOption$integer, _answerOption$integer2, _answerOption$doubleA, _answerOption$doubleA2, _answerOption$boolean, _answerOption$boolean2, _answerOption$idonotk, _answerOption$idonotk2, _answerOption$textAns, _answerOption$textAns2, _answerOption$dateTim, _answerOption$dateTim2, _answerOption$dateAns, _answerOption$dateAns2, _answerOption$monthAn, _answerOption$monthAn2, _answerOption$monthAn3, _answerOption$monthAn4, _answerOption$fileAns, _answerOption$moneyAn, _answerOption$address;

  if (typeof ((_answerOption$integer = answerOption.integerAnswer) === null || _answerOption$integer === void 0 ? void 0 : (_answerOption$integer2 = _answerOption$integer.answeredValue) === null || _answerOption$integer2 === void 0 ? void 0 : _answerOption$integer2.value) === 'number') {
    return true;
  }

  if (typeof ((_answerOption$doubleA = answerOption.doubleAnswer) === null || _answerOption$doubleA === void 0 ? void 0 : (_answerOption$doubleA2 = _answerOption$doubleA.answeredValue) === null || _answerOption$doubleA2 === void 0 ? void 0 : _answerOption$doubleA2.value) === 'number') {
    return true;
  } // Boolean and I don't know answers are valid if they are 'true'


  if (((_answerOption$boolean = answerOption.booleanAnswer) === null || _answerOption$boolean === void 0 ? void 0 : (_answerOption$boolean2 = _answerOption$boolean.answeredValue) === null || _answerOption$boolean2 === void 0 ? void 0 : _answerOption$boolean2.value) === true) {
    return true;
  }

  if (((_answerOption$idonotk = answerOption.idonotknowAnswer) === null || _answerOption$idonotk === void 0 ? void 0 : (_answerOption$idonotk2 = _answerOption$idonotk.answeredValue) === null || _answerOption$idonotk2 === void 0 ? void 0 : _answerOption$idonotk2.value) === true) {
    return true;
  }

  if ((_answerOption$textAns = answerOption.textAnswer) !== null && _answerOption$textAns !== void 0 && (_answerOption$textAns2 = _answerOption$textAns.answeredValue) !== null && _answerOption$textAns2 !== void 0 && _answerOption$textAns2.value) {
    return true;
  }

  if (answerOption.singleChoiceAnswer) {
    var type = answerOption.singleChoiceAnswer.choiceDataType;
    var value = getChoiceValue(answerOption.singleChoiceAnswer.answeredValue, type);
    var emptyValue = getChoiceValue(undefined, type);
    return !compareChoiceValues(value, emptyValue, type);
  }

  if (answerOption.multipleChoicesAnswer) {
    return answerOption.multipleChoicesAnswer.answeredValuesList.length > 0;
  }

  if (typeof ((_answerOption$dateTim = answerOption.dateTimeAnswer) === null || _answerOption$dateTim === void 0 ? void 0 : (_answerOption$dateTim2 = _answerOption$dateTim.answeredDateTime) === null || _answerOption$dateTim2 === void 0 ? void 0 : _answerOption$dateTim2.seconds) === 'number') {
    return true;
  }

  if (typeof ((_answerOption$dateAns = answerOption.dateAnswer) === null || _answerOption$dateAns === void 0 ? void 0 : (_answerOption$dateAns2 = _answerOption$dateAns.answeredDate) === null || _answerOption$dateAns2 === void 0 ? void 0 : _answerOption$dateAns2.seconds) === 'number') {
    return true;
  }

  if (typeof ((_answerOption$monthAn = answerOption.monthAndDayAnswer) === null || _answerOption$monthAn === void 0 ? void 0 : (_answerOption$monthAn2 = _answerOption$monthAn.answeredValue) === null || _answerOption$monthAn2 === void 0 ? void 0 : _answerOption$monthAn2.month) === 'number' && typeof ((_answerOption$monthAn3 = answerOption.monthAndDayAnswer) === null || _answerOption$monthAn3 === void 0 ? void 0 : (_answerOption$monthAn4 = _answerOption$monthAn3.answeredValue) === null || _answerOption$monthAn4 === void 0 ? void 0 : _answerOption$monthAn4.day) === 'number') {
    return true;
  }

  if ((_answerOption$fileAns = answerOption.fileAnswer) !== null && _answerOption$fileAns !== void 0 && _answerOption$fileAns.answeredValuesList) {
    var _answerOption$fileAns2, _answerOption$fileAns3, _answerOption$fileAns4;

    return ((_answerOption$fileAns2 = answerOption.fileAnswer) === null || _answerOption$fileAns2 === void 0 ? void 0 : _answerOption$fileAns2.answeredValuesList.length) > 0 || ((_answerOption$fileAns3 = answerOption.fileAnswer) === null || _answerOption$fileAns3 === void 0 ? void 0 : (_answerOption$fileAns4 = _answerOption$fileAns3.documentsToUpload) === null || _answerOption$fileAns4 === void 0 ? void 0 : _answerOption$fileAns4.length);
  }

  if ((_answerOption$moneyAn = answerOption.moneyAnswer) !== null && _answerOption$moneyAn !== void 0 && _answerOption$moneyAn.answeredMoney) {
    var _answerOption$moneyAn2 = answerOption.moneyAnswer.answeredMoney,
        currencyCode = _answerOption$moneyAn2.currencyCode,
        nanos = _answerOption$moneyAn2.nanos,
        units = _answerOption$moneyAn2.units;
    return Boolean(currencyCode) && typeof nanos === 'number' && typeof units === 'number';
  }

  if ((_answerOption$address = answerOption.addressAnswer) !== null && _answerOption$address !== void 0 && _answerOption$address.answeredValue) {
    var _answerOption$address2 = answerOption.addressAnswer.answeredValue,
        locality = _answerOption$address2.locality,
        regionCode = _answerOption$address2.regionCode,
        postalCode = _answerOption$address2.postalCode,
        administrativeArea = _answerOption$address2.administrativeArea,
        addressLinesList = _answerOption$address2.addressLinesList;

    if (locality && regionCode && postalCode && administrativeArea && addressLinesList) {
      return true;
    }
  }

  return false;
};
export var validateQuestion = function validateQuestion(question) {
  var _question$isOptional;

  if (question.answerOptionsList.length === 0) {
    return false;
  }

  return ((_question$isOptional = question.isOptional) === null || _question$isOptional === void 0 ? void 0 : _question$isOptional.value) || question.answerOptionsList.some(validateAnswerOption);
};
export var uploadIntakeFiles = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(questionsList, watchSafeFetch) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", Promise.all(questionsList.flatMap(function (question) {
              return question.answerOptionsList.map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(answer) {
                  var _answer$fileAnswer, _answer$fileAnswer$do;

                  var attachedFiles, _answer$fileAnswer$an, _answer$fileAnswer2, fileList, newFiles;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!((_answer$fileAnswer = answer.fileAnswer) !== null && _answer$fileAnswer !== void 0 && (_answer$fileAnswer$do = _answer$fileAnswer.documentsToUpload) !== null && _answer$fileAnswer$do !== void 0 && _answer$fileAnswer$do.length)) {
                            _context.next = 5;
                            break;
                          }

                          _context.next = 3;
                          return uploadNewDocuments({
                            documents: answer.fileAnswer.documentsToUpload
                          }, watchSafeFetch);

                        case 3:
                          attachedFiles = _context.sent;

                          if (attachedFiles) {
                            fileList = (_answer$fileAnswer$an = (_answer$fileAnswer2 = answer.fileAnswer) === null || _answer$fileAnswer2 === void 0 ? void 0 : _answer$fileAnswer2.answeredValuesList) !== null && _answer$fileAnswer$an !== void 0 ? _answer$fileAnswer$an : [];
                            newFiles = attachedFiles.map(function (file) {
                              return file.fileUuid;
                            });

                            if (answer.fileAnswer) {
                              answer.fileAnswer.answeredValuesList = [].concat(_toConsumableArray(fileList), _toConsumableArray(newFiles));
                              answer.fileAnswer.documentsToUpload = [];
                            }
                          }

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());
            })));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function uploadIntakeFiles(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var saveAnswer = function saveAnswer(answerOption, answeredValue, country) {
  if (answerOption.textAnswer) {
    return _objectSpread(_objectSpread({}, answerOption), {}, {
      textAnswer: _objectSpread(_objectSpread({}, answerOption.textAnswer), {}, {
        answeredValue: answeredValue ? {
          value: answeredValue
        } : undefined
      })
    });
  }

  if (answerOption.booleanAnswer) {
    return _objectSpread(_objectSpread({}, answerOption), {}, {
      booleanAnswer: _objectSpread(_objectSpread({}, answerOption.booleanAnswer), {}, {
        answeredValue: {
          value: answeredValue
        }
      })
    });
  }

  if (answerOption.integerAnswer) {
    var value = parseInt(answeredValue);
    return _objectSpread(_objectSpread({}, answerOption), {}, {
      integerAnswer: _objectSpread(_objectSpread({}, answerOption.integerAnswer), {}, {
        answeredValue: !Number.isNaN(value) ? {
          value: value
        } : undefined
      })
    });
  }

  if (answerOption.idonotknowAnswer) {
    return _objectSpread(_objectSpread({}, answerOption), {}, {
      idonotknowAnswer: _objectSpread(_objectSpread({}, answerOption.idonotknowAnswer), {}, {
        answeredValue: {
          value: answeredValue
        }
      })
    });
  }

  if (answerOption.dateAnswer) {
    return _objectSpread(_objectSpread({}, answerOption), {}, {
      dateAnswer: _objectSpread(_objectSpread({}, answerOption.dateAnswer), {}, {
        answeredDate: {
          seconds: answeredValue,
          nanos: 0
        }
      })
    });
  }

  if (answerOption.dateTimeAnswer) {
    var _ref5 = answeredValue,
        date = _ref5.date,
        time = _ref5.time;
    return _objectSpread(_objectSpread({}, answerOption), {}, {
      dateTimeAnswer: _objectSpread(_objectSpread({}, answerOption.dateTimeAnswer), {}, {
        answeredDateTime: getDateTimeAnswerValues(date, time)
      })
    });
  }

  if (answerOption.monthAndDayAnswer) {
    var _ref6 = answeredValue,
        month = _ref6.month,
        day = _ref6.day;
    return _objectSpread(_objectSpread({}, answerOption), {}, {
      monthAndDayAnswer: _objectSpread(_objectSpread({}, answerOption.monthAndDayAnswer), {}, {
        answeredValue: {
          day: day !== null && day !== void 0 ? day : 0,
          month: month !== null && month !== void 0 ? month : 0
        }
      })
    });
  }

  if (answerOption.moneyAnswer) {
    var _ref7 = answeredValue,
        amount = _ref7.amount,
        currency = _ref7.currency;

    var _ref8 = amount ? "".concat(amount).split('.') : ['0', '0'],
        _ref9 = _slicedToArray(_ref8, 2),
        unitsRaw = _ref9[0],
        centsRaw = _ref9[1];

    var units = parseInt(unitsRaw);
    var cents = (centsRaw !== null && centsRaw !== void 0 ? centsRaw : '0').padEnd(2, '0');
    var centsParsed = parseInt(cents);
    var nanos = 0;

    if (centsParsed > 0) {
      nanos = centsParsed / Math.pow(10, cents.length) * MONEY_NANOS_MAX;
    }

    return _objectSpread(_objectSpread({}, answerOption), {}, {
      moneyAnswer: _objectSpread(_objectSpread({}, answerOption.moneyAnswer), {}, {
        answeredMoney: {
          units: units,
          nanos: nanos,
          currencyCode: currency
        }
      })
    });
  }

  if (answerOption.singleChoiceAnswer && answeredValue) {
    var type = answerOption.singleChoiceAnswer.choiceDataType;
    var _ref10 = answeredValue,
        selected = _ref10.selected,
        other = _ref10.other;
    var selectedChoice;

    if (selected === OTHER_OPTION_VALUE) {
      selectedChoice = getChoiceAnswerValue(other, type);
    } else {
      selectedChoice = answerOption.singleChoiceAnswer.choicesList.find(function (choice) {
        return compareChoiceValues(selected, getChoiceValue(choice, type, country), type);
      });
    }

    return _objectSpread(_objectSpread({}, answerOption), {}, {
      singleChoiceAnswer: _objectSpread(_objectSpread({}, answerOption.singleChoiceAnswer), {}, {
        answeredValue: selectedChoice
      })
    });
  }

  if (answerOption.multipleChoicesAnswer && answeredValue) {
    var _type = answerOption.multipleChoicesAnswer.choiceDataType;
    var choicesList = answerOption.multipleChoicesAnswer.choicesList;
    var _ref11 = answeredValue,
        _selected = _ref11.selected,
        showOther = _ref11.showOther,
        _other = _ref11.other;

    var choiceValues = _selected.map(function (value) {
      return choicesList.find(function (choice) {
        return compareChoiceValues(value, getChoiceValue(choice, _type, country), _type);
      });
    }).filter(Boolean); // Make sure 'other' value is not already in the list. When editing a question, can save 'other' multiple times


    var alreadyContainsOther = _selected.filter(function (value) {
      return compareChoiceValues(_other, value, _type);
    }).length > 0;

    if (!alreadyContainsOther && showOther) {
      var otherChoice = _objectSpread({
        preselected: false,
        jumpToQuestionWithOrder: 0,
        determinesAnswerOptionsList: []
      }, getChoiceAnswerValue(_other, _type));

      choiceValues.push(otherChoice);
    }

    return _objectSpread(_objectSpread({}, answerOption), {}, {
      multipleChoicesAnswer: _objectSpread(_objectSpread({}, answerOption.multipleChoicesAnswer), {}, {
        answeredValuesList: choiceValues
      })
    });
  }

  if (answerOption.addressAnswer) {
    var _ref12 = answeredValue,
        city = _ref12.city,
        _country = _ref12.country,
        postalCode = _ref12.postalCode,
        region = _ref12.region,
        street1 = _ref12.street1,
        street2 = _ref12.street2;
    return _objectSpread(_objectSpread({}, answerOption), {}, {
      addressAnswer: _objectSpread(_objectSpread({}, answerOption.addressAnswer), {}, {
        answeredValue: {
          locality: city,
          regionCode: _country,
          postalCode: postalCode,
          administrativeArea: region,
          addressLinesList: [street1, street2]
        }
      })
    });
  }

  if (answerOption.fileAnswer) {
    var _ref13 = answeredValue,
        fileList = _ref13.fileList,
        documentsToUpload = _ref13.documentsToUpload;
    return _objectSpread(_objectSpread({}, answerOption), {}, {
      fileAnswer: _objectSpread(_objectSpread({}, answerOption.fileAnswer), {}, {
        answeredValuesList: fileList,
        documentsToUpload: documentsToUpload
      })
    });
  }

  return answerOption;
};
export var answerValuesToQuestion = function answerValuesToQuestion(question, values, country) {
  var answeredOptions = question.answerOptionsList.sort(answerOptionSortFn).map(function (answerOption, index) {
    var value = answerOption.idonotknowAnswer ? values[question.id][I_DO_NOT_KNOW_ID] : values[question.id][index];
    return saveAnswer(answerOption, value, country);
  });
  return _objectSpread(_objectSpread({}, question), {}, {
    answerOptionsList: answeredOptions,
    presentedAnswerOptionsList: question.presentedAnswerOptionsList
  });
};